import React from 'react';
import { observer } from 'mobx-react';
import useStores from '../../hooks/useStores';

import Card from '../Card';

import * as S from './styles';

function CardItemList({ onClickCard }) {
  const { CardWallet } = useStores();

  return (
    <S.Container>
      {CardWallet.list.map((cardData, index) => (
        <Card key={cardData.id} {...cardData} isMargin={false} onClick={() => onClickCard(index)} />
      ))}
    </S.Container>
  );
}

export default observer(CardItemList);
